var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16ZM9 2.091V4a1 1 0 1 1-2 0V2.091A5.984 5.984 0 0 0 2.1 7H4a1 1 0 0 1 0 2H2.1A5.984 5.984 0 0 0 7 13.909V12a1 1 0 1 1 2 0v1.909A5.984 5.984 0 0 0 13.9 9H12a1 1 0 1 1 0-2h1.9A5.984 5.984 0 0 0 9 2.091Z",
    clipRule: "evenodd"
  })));
};
export default SvgTarget;